// helpers
import bookingEstimateHasPrice from "@cloudspire/legacy-resources/src/helpers/booking/estimate/hasPrice";

/**
 * Retourne le montant de l'estimation du tarif.
 */
export default function bookingEstimateGetPrice({
  bookingEstimate,
  isBookable,
}) {
  if (!bookingEstimateHasPrice({ bookingEstimate })) {
    return null;
  }

  if (!isBookable) {
    return bookingEstimate.tripAmount - bookingEstimate.serviceFeeAmount;
  }

  return bookingEstimate.tripAmount;
}
